import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyComponentProps {
  message?: string;
  textColor?: string;
}

const EmptyComponent: React.FC<EmptyComponentProps> = ({
  message,
  textColor = "textPrimary",
}) => {
  return (
    <Box
      p={4}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="200px"
    >
      <Typography variant="body1" color={textColor}>
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyComponent;

